module.exports = __webpack_public_path__ + "static/img/shinsegae-department.be6bb49.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/shinsegae-department.jpg
// module id = e6Dl
// module chunks = 0